module.exports = __webpack_public_path__ + "static/media/Strengths_MihirPate.f853f3e6.pdf";